import { CustomError } from './Models/CustomError';

export function isCustomError(error: any): error is CustomError {
  return (error as CustomError).errors !== undefined;
}
